
    import "/home/git/waysglob/website/src/pages/solutions/main.module.scss.FARM_CSS_MODULES?cf405a3b";
    
    export default {"title": `title-3715d972`,"subtitle": `subtitle-3715d972`}
    